import { create } from "../../helpers/services/main-socket-client";
import {
  addInstagramMessageAction,
  addFacebookMessageAction,
  addLinkedinMessageAction,
  addLinkedinBusinessMessageAction,
  addWhatsappMessageAction,
  addWhatsappConversationAction,
  changeSocialConversationStatusAction,
} from "../../socialChat/store/actions";
import {
  addConversationAction,
  addWebMessageAction,
  changeConversationStatusAction,
} from "../../conversations/store/actions";
import { MessageType } from "../constant/messageType.constant";
import { SocketAction } from "../constant/socketAction.constant";
import {
  addNewNotificationAction,
  addOnlineClientAction,
  deleteOnlineClientAction,
  socketDisconnectedAction,
} from "../store/actions";
import {
  leaveFromChannelAction,
  sendMessageToChannelAction,
  subscribeToChannelAction,
} from "../store/socket-actions";
import {
  addSupportMessageAction,
  removeSupportVisitorAction,
  setSupportOnlineAgentsAction,
  upsertSupportConversationAction,
  upsertSupportVisitorAction,
} from "../../wembiiSupport/store/actions";
import {
  sendWembiiSupportMessageAction,
  subscribeWembiiSupportAgentAction,
  subscribeWembiiSupportClientAction,
  disconnectWembiiSupportClientAction,
} from "../../wembiiSupport/store/socket-actions";
import { resetAction } from "../../globals/store/actions";
import { wembiiSupportApiService } from "../../wembiiSupport/services/api";
import {
  clearSupportConversationId,
  readSupportConversationId,
} from "../../wembiiSupport/supportSessionStorage";
import { Socket } from "socket.io-client";

function endActiveSupportSession(store: any, socket: Socket | null) {
  const conversationId =
    store.getState().wembiiSupport?.widgetSession?.conversationId ||
    readSupportConversationId();
  if (!conversationId) return;
  socket?.emit(SocketAction.WEMBII_SUPPORT_CLIENT_DISCONNECT, { conversationId });
  wembiiSupportApiService.endSession(conversationId).catch(() => undefined);
  clearSupportConversationId();
}
export const socketMiddleware = () => {
  let socket: Socket | null;

  return (store: any) => {
    socket = create();
    const initializeSocket = () => {
      const handleSocketEvents = () => {
        
        socket?.on(SocketAction.MESSAGE, (data: any) => {
          switch (data.type) {
            case MessageType.FACEBOOK:
              store.dispatch(
                addFacebookMessageAction({
                  message: data.message,
                  id: data.id,
                })
              );
              break;
            case MessageType.INSTAGRAM:
              store.dispatch(
                addInstagramMessageAction({
                  message: data.message,
                  id: data.id,
                })
              );
              break;
            case MessageType.WEB:
              store.dispatch(
                addWebMessageAction({
                  message: data.message,
                  id: data.id,
                })
              );
              break;
            case MessageType.WHATSAPP:
              store.dispatch(
                addWhatsappMessageAction({
                  message: data.message,
                  id: data.id,
                })
              );
              break;
            case MessageType.LINKEDIN:
              store.dispatch(
                addLinkedinMessageAction({
                  message: data.message,
                  id: data.id,
                })
              );
              break;
            case MessageType.LINKEDIN_BUSINESS:
              store.dispatch(
                addLinkedinBusinessMessageAction({
                  message: data.message,
                  id: data.id,
                })
              );
              break;
          }
        });

        socket?.on(SocketAction.CONVERSATION, (data: any) => {
          switch (data.type) {
            case MessageType.WHATSAPP:
              store.dispatch(
                addWhatsappConversationAction({
                  conversation: data.conversation,
                })
              );
              break;
            case MessageType.WEB:
              store.dispatch(
                addConversationAction({
                  conversation: data.conversation,
                })
              );
              break;
          }
        });

        socket?.on(SocketAction.NOTIFICATION, (data: any) => {
          store.dispatch(addNewNotificationAction({ id: data.id }));
        });

        socket?.on(SocketAction.ONLINE, (data: any) => {
          store.dispatch(addOnlineClientAction({ id: data.contactId }));
        });

        socket?.on(SocketAction.OFFLINE, (id: string) => {
          store.dispatch(deleteOnlineClientAction({ id }));
        });

        socket?.on(SocketAction.CONVERSATION_STATUS, (data: any) => {
          if (data.type === "web") {
            store.dispatch(
              changeConversationStatusAction({
                conversation: data,
                conversationStatus:
                  store.getState().socialChat.conversationStatus,
              })
            );
          } else {
            store.dispatch(
              changeSocialConversationStatusAction({
                conversation: data,
              })
            );
          }
        });

        socket?.on(SocketAction.WEMBII_SUPPORT_MESSAGE, (data: any) => {
          if (data?.message) {
            store.dispatch(
              addSupportMessageAction({
                message: data.message,
                conversationId: data.id,
              })
            );
          }
        });

        socket?.on(SocketAction.WEMBII_SUPPORT_CONVERSATION, (data: any) => {
          if (data?.conversation) {
            store.dispatch(
              upsertSupportConversationAction({
                conversation: data.conversation,
              })
            );
          }
        });

        socket?.on(SocketAction.WEMBII_SUPPORT_VISITOR_ONLINE, (data: any) => {
          if (data?.visitor) {
            store.dispatch(
              upsertSupportVisitorAction({ visitor: data.visitor })
            );
          }
        });

        socket?.on(SocketAction.WEMBII_SUPPORT_VISITOR_OFFLINE, (data: any) => {
          const visitorId = data?.visitor?.id
            ? String(data.visitor.id)
            : data?.visitor?.userId
            ? String(data.visitor.userId)
            : null;
          if (visitorId) {
            store.dispatch(removeSupportVisitorAction({ id: visitorId }));
          }
        });

        socket?.on(SocketAction.WEMBII_SUPPORT_AGENTS_ONLINE, (data: any) => {
          if (Array.isArray(data?.agents)) {
            store.dispatch(
              setSupportOnlineAgentsAction({ agents: data.agents })
            );
          }
        });

        socket?.on("connect", () => {
          store.dispatch(socketDisconnectedAction({ disconnected: false }));
          const agentSub =
            store.getState().wembiiSupport.agentSocketSubscription;
          if (agentSub?.userId) {
            socket?.emit(SocketAction.WEMBII_SUPPORT_SUBSCRIBE, {
              userId: agentSub.userId,
              conversationId: agentSub.conversationId,
              room: agentSub.room,
            });
          }
        });

        socket?.on("disconnect", () => {
          store.dispatch(socketDisconnectedAction({ disconnected: true }));
        });
      };

      handleSocketEvents();

      return () => {
        socket?.disconnect();
        socket = null;
      };
    };
    initializeSocket();
    return (next: any) => (action: any) => {
      switch (action.type) {
        case subscribeToChannelAction.type:
          socket?.emit(SocketAction.SUBSCRIBE, {
            userId: action.userId,
            conversationId: action.conversationId,
            channel: action.channel,
            companyId: action.companyId,
          });
          break;
        case leaveFromChannelAction.type:
          socket?.emit(SocketAction.LEAVE, { channel: action.channel });
          break;
        case sendMessageToChannelAction.type:
          socket?.emit(SocketAction.WEB_MESSAGE, {
            ...action.message,
            channel: action.channel,
          });
          break;
        case subscribeWembiiSupportAgentAction.type:
          socket?.emit(SocketAction.WEMBII_SUPPORT_SUBSCRIBE, {
            userId: action.userId,
            conversationId: action.conversationId,
            room: action.room,
          });
          break;
        case subscribeWembiiSupportClientAction.type:
          socket?.emit(SocketAction.WEMBII_SUPPORT_CLIENT_SUBSCRIBE, {
            userId: action.userId,
            conversationId: action.conversationId,
            room: action.room,
          });
          break;
        case sendWembiiSupportMessageAction.type:
          socket?.emit(SocketAction.WEMBII_SUPPORT_MESSAGE, {
            conversationId: action.conversationId,
            content: action.content,
            senderType: action.senderType,
            senderId: action.senderId,
            consultationLabel: action.consultationLabel,
          });
          break;
        case disconnectWembiiSupportClientAction.type:
          socket?.emit(SocketAction.WEMBII_SUPPORT_CLIENT_DISCONNECT, {
            conversationId: action.conversationId,
          });
          break;
        case resetAction.type:
          endActiveSupportSession(store, socket);
          return next(action);
        default:
          return next(action);
      }
    };
  };
};
